import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { Typography } from "antd";
import { MinusOutlined } from "@ant-design/icons";

function LineChartTransactionsByStatus() {
  const { Title, Paragraph } = Typography;

  const [chartData, setChartData] = useState({
    options: {
      chart: {
        toolbar: { show: false },
        zoom: { enabled: false },
      },
      colors: ["#00E396", "#FEB019", "#FF4560"], // Completed, Pending, Failed
      dataLabels: { enabled: false },
      stroke: { curve: "smooth", width: 5 },
      xaxis: {
        categories: [
          "Jan",
          "Fév",
          "Mar",
          "Avr",
          "Mai",
          "Juin",
          "Juil",
          "Août",
          "Sep",
          "Oct",
          "Nov",
          "Déc",
        ],
        labels: {
          style: {
            colors: Array(12).fill("gray"),
            fontSize: "12px",
            fontWeight: "bold",
          },
        },
      },
      yaxis: {
        labels: {
          formatter: (val) => `${val.toLocaleString("fr-FR")} XOF`,
          style: {
            colors: ["gray"],
            fontSize: "12px",
            fontWeight: "bold",
          },
        },
      },
      tooltip: {
        y: { formatter: (val) => `${val.toLocaleString("fr-FR")} XOF` },
      },
      legend: {
        labels: { colors: "#FFFFFF" }, // Légende en blanc
      },
    },
    series: [
      { name: "Completed", data: Array(12).fill(0) },
      { name: "Pending", data: Array(12).fill(0) },
      { name: "Failed", data: Array(12).fill(0) },
    ],
  });

  const [totalAmounts, setTotalAmounts] = useState({
    completed: 0,
    pending: 0,
    failed: 0,
  });

  useEffect(() => {
    const fetchTransactions = async () => {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_API_URL}/api/transactions`
        );
        if (!res.ok) throw new Error("Erreur API transactions");
        const transactions = await res.json();

        const completed = Array(12).fill(0);
        const pending = Array(12).fill(0);
        const failed = Array(12).fill(0);

        let totalCompleted = 0;
        let totalPending = 0;
        let totalFailed = 0;

        transactions.forEach((tx) => {
          const monthIndex = new Date(tx.createdAt).getMonth();
          const amount = tx.amount || 0;

          if (tx.status === "success") {
            completed[monthIndex] += amount;
            totalCompleted += amount;
          } else if (tx.status === "pending") {
            pending[monthIndex] += amount;
            totalPending += amount;
          } else if (tx.status === "failed") {
            failed[monthIndex] += amount;
            totalFailed += amount;
          }
        });

        setTotalAmounts({
          completed: totalCompleted,
          pending: totalPending,
          failed: totalFailed,
        });

        setChartData((prev) => ({
          ...prev,
          series: [
            { name: "Completed", data: completed },
            { name: "Pending", data: pending },
            { name: "Failed", data: failed },
          ],
        }));
      } catch (err) {
        console.error("Erreur récupération transactions par mois:", err);
      }
    };

    fetchTransactions();
  }, []);

  return (
    <>
      <div className="linechart">
        <div>
          <Title level={5}>Transactions par mois (statut)</Title>
          <Paragraph className="lastweek">
            ✅ Completed:{" "}
            <span className="bnb2">
              {totalAmounts.completed.toLocaleString("fr-FR")} XOF
            </span>{" "}
            | ⏳ Pending:{" "}
            <span className="bnb2">
              {totalAmounts.pending.toLocaleString("fr-FR")} XOF
            </span>{" "}
            | ❌ Failed:{" "}
            <span className="bnb2">
              {totalAmounts.failed.toLocaleString("fr-FR")} XOF
            </span>
          </Paragraph>
        </div>
        <div className="sales">
          <ul>
            <li>
              <MinusOutlined style={{ color: "#00E396" }} /> Completed
            </li>
            <li>
              <MinusOutlined style={{ color: "#FEB019" }} /> Pending
            </li>
            <li>
              <MinusOutlined style={{ color: "#FF4560" }} /> Failed
            </li>
          </ul>
        </div>
      </div>

      <ReactApexChart
        className="full-width"
        options={chartData.options}
        series={chartData.series}
        type="area"
        height={350}
        width={"100%"}
      />
    </>
  );
}

export default LineChartTransactionsByStatus;
